import dialogs from './dialogs.js'
import store from '../../store'
import vStrategyForm from './StrategyForm.vue'
import vStrategySelector from './StrategySelector.vue'
import vEditorForm from './EditorForm.vue'
import vEmailForm from './EmailForm.vue'

export default {
  openFormStg (strategy, itemId) {
    return new Promise((resolve, reject) => {
      dialogs.register('v-strategy-form', vStrategyForm)
      var fullscreen = store.getters.getIsMobile
      strategy.updateSteps()
      var comp = { template: `
        <v-strategy-form
        :itemId="itemId"
        :strategy="strategy"
        v-on:close="$emit('close')"
        v-on:change="onChange"
        v-on:createNew="onCreateNew"
        :fullscreen="fullscreen"></v-strategy-form>
        `,
        data () {
          return {
            fullscreen: fullscreen,
            onChange: (data) => resolve(data),
            onCreateNew: (data) => {
              this.itemId = null
            },
            itemId: itemId ? itemId.toString() : null,
            strategy: strategy
          }
        }}
      dialogs.modal(comp)
    })
  },
  selectItem (items, selected, title) {
    return new Promise((resolve, reject) => {
      dialogs.register('strategy-selector', vStrategySelector)
      var fullscreen = store.getters.getIsMobile
      var comp = { template: `
        <strategy-selector radio :fullscreen="fullscreen" :items="items" :selected="selected" :title="title" v-on:input="onSelect" v-on:close="$emit('close')"></strategy-selector>
      `,
        data () {
          return {
            selected: selected,
            onSelect: (data) => resolve(data),
            fullscreen: fullscreen,
            items: items,
            title: title
          }
        }
      }
      dialogs.modal(comp)
    })
  },
  openEditor (value) {
    console.log('openEditor', value)
    return new Promise((resolve, reject) => {
      dialogs.register('v-editor-form', vEditorForm)
      var fullscreen = store.getters.getIsMobile
      var comp = { template: `
        <v-editor-form
        :value="value"
        v-on:close="$emit('close')"
        v-on:change="onChange"
        :fullscreen="fullscreen"></v-editor-form>
        `,
        data () {
          return {
            fullscreen: fullscreen,
            onChange: (data) => resolve(data),
            value: value
          }
        }}
      dialogs.modal(comp)
    })
  },
  openEmail (value) {
    console.log('openEmail', value)
    return new Promise((resolve, reject) => {
      dialogs.register('v-email-form', vEmailForm)
      var fullscreen = store.getters.getIsMobile
      var comp = { template: `
        <v-email-form
        :model="value"
        v-on:close="$emit('close')"
        v-on:change="onChange"
        :fullscreen="fullscreen"></v-email-form>
        `,
        data () {
          return {
            fullscreen: fullscreen,
            onChange: (data) => resolve(data),
            value: value
          }
        }}
      dialogs.modal(comp)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/common/forms.js